/**
 * @generated SignedSource<<64deacf8eaf22cf407a097b881bc2dec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ComplexProductsAppropriatenessQuestionType = "SINGLE_CHOICE";
export type ComplexProductsAppropriatenessQuestionsViewQuery$variables = Record<PropertyKey, never>;
export type ComplexProductsAppropriatenessQuestionsViewQuery$data = {
  readonly complexProductsAppropriatenessQuestions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ComplexProductsAppropriatenessQuestion";
        readonly answers: ReadonlyArray<{
          readonly answer: string | null | undefined;
          readonly id: string;
        }>;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly question: string | null | undefined;
        readonly type: ComplexProductsAppropriatenessQuestionType | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ComplexProductsAppropriatenessQuestionsViewQuery = {
  response: ComplexProductsAppropriatenessQuestionsViewQuery$data;
  variables: ComplexProductsAppropriatenessQuestionsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ComplexProductsAppropriatenessQuestionsConnection",
    "kind": "LinkedField",
    "name": "complexProductsAppropriatenessQuestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ComplexProductsAppropriatenessQuestionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ComplexProductsAppropriatenessQuestion",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "question",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ComplexProductsAppropriatenessAnswer",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ComplexProductsAppropriatenessQuestionsViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ComplexProductsAppropriatenessQuestionsViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0e1a4367eb96abc765f887a6e2e24d7",
    "id": null,
    "metadata": {},
    "name": "ComplexProductsAppropriatenessQuestionsViewQuery",
    "operationKind": "query",
    "text": "query ComplexProductsAppropriatenessQuestionsViewQuery {\n  complexProductsAppropriatenessQuestions {\n    edges {\n      node {\n        id\n        question\n        description\n        type\n        answers {\n          id\n          answer\n        }\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac855027be6ad6a712270a289fc40d5a";

export default node;
